import jsPDF from "jspdf";
import { loadAndAddFonts } from "../../../../PDFsFunctions/fontsPDF";
import { centeredText, getStyle } from "../../../../PDFsFunctions/textUtilsPDF";
import { colors, fontSize } from "../../../../PDFsFunctions/configPDF";

const CashAuditPDF = async (auditData) => {
    const generatePDF = async () => {
        const format = (value) => parseFloat(value).toFixed(2);

        var contentHeight = 190;
        const margins = { top: 5, left: 5, right: 5, bottom: 5 };
        const lineBreak = 5;
        const newParagraph = 8;
        const fontSize = 9;
        var currentPageLine = margins.top;

        const pdf = new jsPDF({
            unit: 'mm',
            format: [58, contentHeight],
        });

        await loadAndAddFonts(pdf);

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const contentWidth = pageWidth - margins.left - margins.right;

        function nameReduced(name) {
            const parts = name.trim().split(/\s+/);
            if (parts.length === 1) return parts[0];
            const firstName = parts[0];
            const lastName = parts[parts.length - 2];
            return `${firstName} ${lastName}`;
        }

        currentPageLine = 15;
        getStyle(pdf, 'bold', '', 16)
        pdf.text('Corte de caja', margins.left + centeredText(pdf, contentWidth, 'Corte de caja'), currentPageLine);

        getStyle(pdf, 'bold', '', fontSize)
        currentPageLine += newParagraph;
        pdf.text('FOLIO: ' + auditData.folio, margins.left, currentPageLine);
        currentPageLine += lineBreak;
        getStyle(pdf, 'bold', '#000', fontSize);

        let completeName = auditData.receptionist.name;
        let txtRecep = 'Recepcionista:' + completeName;
        let recepNameW = pdf.getTextWidth(txtRecep);

        if (contentWidth > recepNameW) {
            pdf.text(txtRecep, margins.left, currentPageLine);
        } else {
            let nombreReducido = nameReduced(completeName);
            let textoReducido = 'Recepcionista: ' + nombreReducido;
            if (pdf.getTextWidth(textoReducido) <= contentWidth) {
                pdf.text(textoReducido, margins.left, currentPageLine);
            } else {
                pdf.text('Recepcionista:', margins.left, currentPageLine);
                currentPageLine += lineBreak;
                pdf.text(nombreReducido, margins.left, currentPageLine);
            }
        }

        getStyle(pdf, 'normal', '#000', fontSize);
        currentPageLine += lineBreak;
        pdf.text('Sucursal: ' + auditData.subsidiary_name, margins.left, currentPageLine);
        currentPageLine += lineBreak;
        pdf.text('Inicio: ' + auditData.start_datetime, margins.left, currentPageLine);
        currentPageLine += lineBreak;
        pdf.text('Cierre: ' + auditData.end_datetime, margins.left, currentPageLine);
        currentPageLine += lineBreak - 2;

        pdf.line(margins.left, currentPageLine, margins.left + contentWidth, currentPageLine);
        currentPageLine += lineBreak;
        getStyle(pdf, 'bold', '#000', fontSize);
        pdf.text('EFECTIVO', margins.left, currentPageLine);
        currentPageLine += lineBreak - 2;
        getStyle(pdf, 'normal', '#000', fontSize);
        pdf.line(margins.left, currentPageLine, margins.left + contentWidth, currentPageLine);
        currentPageLine += lineBreak;

        getStyle(pdf, 'bold', '#000', fontSize);
        pdf.text('EFECTIVO EN SISTEMA', margins.left, currentPageLine);
        getStyle(pdf, 'normal', '#000', fontSize);
        currentPageLine += lineBreak;
        pdf.text('MXN', margins.left, currentPageLine);
        pdf.text(`${format(auditData.cash_mxn)}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += lineBreak;
        pdf.text(`USD (${format(auditData.cash_usd)})`, margins.left, currentPageLine);
        pdf.text(`MXN ${format(auditData.usd_to_mxn)}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += newParagraph;

        getStyle(pdf, 'bold', '#000', fontSize);
        pdf.text('EFECTIVO REAL', margins.left, currentPageLine);
        getStyle(pdf, 'normal', '#000', fontSize);
        currentPageLine += lineBreak;
        pdf.text('MXN ', margins.left, currentPageLine);
        pdf.text(`${format(auditData.cash_mxn_received)}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += lineBreak;
        pdf.text(`USD (${format(auditData.cash_usd_received)})`, margins.left, currentPageLine);
        pdf.text(`MXN ${format(parseFloat(auditData.cash_usd_received) * parseFloat(auditData.average_usd_exchange_rate))}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += lineBreak;

        pdf.setFillColor(colors['lightgray']);
        pdf.rect(margins.left, currentPageLine, contentWidth, 7, 'F');
        currentPageLine += lineBreak;
        pdf.text('Total Efectivo', margins.left + 5, currentPageLine);
        pdf.text(`${format(parseFloat(auditData.usd_to_mxn) + parseFloat(auditData.cash_mxn))}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += newParagraph;

        pdf.setFillColor(colors['lightgray']);
        pdf.rect(margins.left, currentPageLine, contentWidth, 7, 'F');
        currentPageLine += lineBreak;
        pdf.text('Total Efectivo Real', margins.left + 5, currentPageLine);
        pdf.text(`${format((parseFloat(auditData.cash_usd_received) * parseFloat(auditData.average_usd_exchange_rate)) + parseFloat(auditData.cash_mxn_received))}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += newParagraph;
        pdf.text('Fondo', margins.left, currentPageLine);
        pdf.text('____________', margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += lineBreak;
        getStyle(pdf, 'normal', '#000', fontSize);

        pdf.line(margins.left, currentPageLine, margins.left + contentWidth, currentPageLine);
        currentPageLine += lineBreak;
        getStyle(pdf, 'bold', '#000', fontSize);
        pdf.text('PAGOS ELECTRÓNICOS', margins.left, currentPageLine);
        currentPageLine += lineBreak - 2;
        getStyle(pdf, 'normal', '#000', fontSize);
        pdf.line(margins.left, currentPageLine, margins.left + contentWidth, currentPageLine);
        currentPageLine += lineBreak;

        pdf.text('Total tarjeta', margins.left, currentPageLine);
        pdf.text(`${format(parseFloat(auditData.card_credit_total) + parseFloat(auditData.card_debit_total))}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += lineBreak;
        pdf.text('Total transferencia', margins.left, currentPageLine);
        pdf.text(`${format(auditData.transfer_total)}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += lineBreak;

        currentPageLine += lineBreak;
        getStyle(pdf, 'bold', '#000', fontSize);
        pdf.text('Total electrónico: ', margins.left + 5, currentPageLine);
        pdf.text(`${format(parseFloat(auditData.card_credit_total) + parseFloat(auditData.card_debit_total) + parseFloat(auditData.transfer_total))}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        getStyle(pdf, 'normal', '#000', fontSize);

        currentPageLine += newParagraph;
        pdf.line(margins.left, currentPageLine, margins.left + contentWidth, currentPageLine);
        pdf.setFillColor(colors['lightgray']);
        pdf.rect(margins.left, currentPageLine, contentWidth, 7, 'F');
        currentPageLine += lineBreak;
        pdf.text('Importe total: ', margins.left + 5, currentPageLine);
        pdf.text(`${format(auditData.total_amount_received)}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += newParagraph;

        getStyle(pdf, 'normal', '#000', fontSize);
        pdf.text('Total en sistema: ', margins.left, currentPageLine);
        pdf.text(`${format(auditData.total_amount)}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += lineBreak;
        pdf.text('Descuadre:', margins.left, currentPageLine);
        pdf.text(`${format(auditData.discrepancy)}`, margins.left + contentWidth - 5, currentPageLine, { align: "right" });
        currentPageLine += lineBreak;

        // pdf.text('---------------------------', margins.left, currentPageLine,);
        // currentPageLine += lineBreak;
        // pdf.text('Libros vendidos: ' + auditData.books_qty, margins.left, currentPageLine,);
        // currentPageLine += lineBreak;
        //Esto creo que por el momento podria quedar pendiente
        // pdf.text('Promociones aplicados: ' + auditData.discounts.amount, margins.left, currentPageLine,);
        // currentPageLine += lineBreak;
        // pdf.text('Autorización: ' + auditData.discounts.autorized.name, margins.left, currentPageLine,);
        // currentPageLine += lineBreak;
        return pdf;
    };
    return await generatePDF();
};
export default CashAuditPDF;
